export default {
  // Dashboard
  DASHBOARD: '/dashboard',

  // Invite User
  INVITEUSER: '/invite-user',

  // User Detail
  USERDETAIL: '/user-detail',

  // Edit User
  EDITUSER: '/edit-user',

  // User List
  USER_LIST: '/user-list',

  // White label
  WHITE_LABEL: '/white-label',

  // Permission
  PERMISSION: '/permission',

  // Message
  MESSAGE: '/Message',

  // team list
  TEAM_LIST: '/team-list',

  // BulkUpload
  BULK_UPLOAD: '/bulk-upload',

  // Data export
  DATA_EXPORT: '/data-export',

  USER_ANALYTICS: '/user-analytics',

  ERROR_PAGE: '/error',

  LOADING_PAGE: '/loading',

  MAINTENANCE_MODE: '/maintenance-mode',
};
